module.exports = __webpack_public_path__ + "1c486ceab6982f158826488210576f8b.svg";